export default (value: string | null) => {
  const allLettersRegex = /[a-z]/i

  if (value && !allLettersRegex.test(value)) {
    return "The value needs to contain at least one letter"
  }

  return true
}
